import { createSlice } from '@reduxjs/toolkit';

const knowledgeSlice = createSlice({
  name: 'knowledge',
  initialState: {
    documents: [],
    tags: [],
    reviews: [],
    selectedDocument: null,
    selectedTag: null,
    isLoading: false,
    error: null,
    stats: {
      totalDocuments: 0,
      totalSOPs: 0,
      pendingReview: 0,
      totalCategories: 0,
    },
    searchResults: [],
    searchQuery: '',
  },
  reducers: {
    setDocuments(state, action) {
      state.documents = action.payload;
    },
    setTags(state, action) {
      state.tags = action.payload;
    },
    setReviews(state, action) {
      state.reviews = action.payload;
    },
    setSelectedDocument(state, action) {
      state.selectedDocument = action.payload;
    },
    setSelectedTag(state, action) {
      state.selectedTag = action.payload;
    },
    setLoading(state, action) {
      state.isLoading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setStats(state, action) {
      state.stats = { ...state.stats, ...action.payload };
    },
    setSearchResults(state, action) {
      state.searchResults = action.payload;
    },
    setSearchQuery(state, action) {
      state.searchQuery = action.payload;
    },
    addDocument(state, action) {
      state.documents.push(action.payload);
    },
    updateDocument(state, action) {
      const index = state.documents.findIndex(d => d.id === action.payload.id);
      if (index !== -1) {
        state.documents[index] = action.payload;
      }
    },
    removeDocument(state, action) {
      state.documents = state.documents.filter(d => d.id !== action.payload);
    },
    addTag(state, action) {
      state.tags.push(action.payload);
    },
    updateTag(state, action) {
      const index = state.tags.findIndex(t => t.id === action.payload.id);
      if (index !== -1) {
        state.tags[index] = action.payload;
      }
    },
    removeTag(state, action) {
      state.tags = state.tags.filter(t => t.id !== action.payload);
    },
    clearKnowledgeState(state) {
      state.documents = [];
      state.tags = [];
      state.reviews = [];
      state.selectedDocument = null;
      state.selectedTag = null;
      state.searchResults = [];
      state.searchQuery = '';
      state.error = null;
    },
  },
});

export const knowledgeActions = knowledgeSlice.actions;

export default knowledgeSlice;

